import { Row } from "react-bootstrap";
import { useState, useRef, useEffect } from 'react';
import { Button, Input, Space, Table, Form, InputNumber, Empty, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
// import RefreshIcon from '@mui/icons-material/Refresh';
import Highlighter from 'react-highlight-words';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';

import {
  setFile, getStyle, getObjective, getServices, getObjectiveCheck
} from '../../libs/todoSlice'
//function edit table
const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  const params = useParams()

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
// end edit table
const AddSuccess = ({ memberOneSuccess, memberCASuccess }) => {
  const params = useParams()
  const dispatch = useDispatch()
  const style = useSelector(getStyle)
  const objective = useSelector(getObjective)
  const services = useSelector(getServices)
  const objectiveCheck = useSelector(getObjectiveCheck)
  // function show member to success table
  useEffect(() => {
    setData(memberOneSuccess.map((members) => {
      const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
      const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
      const title_en = title_en_list[title_th_list.indexOf(members.request.title_th)]
      return {
        index: members.request.index,
        contract_no: members.request.contract_no,
        employee_id: members.request.employee_id,
        title_th: members.request.title_th ? members.request.title_th : members.request.account_title_th,
        title_en: title_en ? title_en : members.request.account_title_eng,
        title_special_th: members.request.title_special_th,
        special_title_th: members.request.special_title_th,
        special_title_eng: members.request.special_title_eng,
        nickname_th: members.request.nickname_th,
        nickname_eng: members.request.nickname_eng,
        degree: members.request.degree,
        birth_date: members.request.birth_date,
        major: members.request.major,
        minor: members.request.minor,
        status: members.request.status,
        student_id: members.request.student_id,
        username: members.request.username,
        password: members.request.password,
        faculty: members.request.faculty,
        name_th: members.request.name_th ? members.request.name_th : members.request.first_name_th,
        surname_th: members.request.surname_th ? members.request.surname_th : members.request.last_name_th,
        name_eng: members.request.name_eng ? members.request.name_eng : members.request.first_name_eng,
        surname_eng: members.request.surname_eng ? members.request.surname_eng : members.request.last_name_eng,
        cid: members.request.cid ? members.request.cid : members.request.id_card_num,
        address: members.request.address,
        tel: members.request.tel,
        mobile: members.request.mobile ? members.request.mobile : members.request.mobile_no,
        email: members.request.email,
        biz_email: members.request.biz_email,
        position: members.request.position,
        department: members.request.department,
        sub_organization: members.request.sub_organization,
        organization: members.request.organization,
        tax_id: members.request.tax_id,
        maintainer_name_1: members.request.maintainer_name_1,
        maintainer_surname_1: members.request.maintainer_surname_1,
        maintainer_name_2: members.request.maintainer_name_2,
        maintainer_surname_2: members.request.maintainer_surname_2,
        maintainer_email_1: members.request.maintainer_email_1,
        maintainer_email_2: members.request.maintainer_email_2,
        maintainer_tel_1: members.request.maintainer_tel_1,
        maintainer_tel_2: members.request.maintainer_tel_2,
        maintainer_name_3: members.request.maintainer_name_3,
        maintainer_surname_3: members.request.maintainer_surname_3,
        maintainer_email_3: members.request.maintainer_email_3,
        maintainer_tel_3: members.request.maintainer_tel_3,
        maintainer_name_4: members.request.maintainer_name_4,
        maintainer_surname_4: members.request.maintainer_surname_4,
        maintainer_email_4: members.request.maintainer_email_4,
        maintainer_tel_4: members.request.maintainer_tel_4,
        is_duplicate: members.is_duplicate ?? false,
      }
    }))
  }, [memberOneSuccess])
  // end function show member to success table
  //function edit table
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.index === editingKey;

  const cancel = () => {
    setEditingKey('');
  };


  // function search
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const customLocale = {
    emptyText: (<Empty
      description="ไม่มีข้อมูล"
    />)
  };


  const mergedColumns = [
    {
      title: 'ลำดับที่',
      dataIndex: 'index',
      width: 100,
      show: true,
      editable: true,
      fixed: 'left',
      render: (__, _, index) => parseInt(index) + 1,
    },
    {
      title: 'เลขที่สัญญา',
      dataIndex: 'contract_no',
      width: 150,
      editable: true,
      fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: objective.includes('เลขที่หนังสือสัญญา')
      // ...getColumnSearchProps('contract_no'),
    },
    {
      title: 'รหัสพนักงาน',
      dataIndex: 'employee_id',
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
    },
    {
      title: 'คำนำหน้า',
      dataIndex: 'title_th',
      width: 150,
      // width: '10%',
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('title_th'),
    },
    {
      title: 'คำนำหน้า (ภาษาอังกฤษ)',
      dataIndex: 'title_en',
      width: 150,
      // width: '10%',
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('title_th'),
    },
    {
      title: 'คำนำหน้านาม',
      dataIndex: 'title_special_th',
      width: 150,
      show: objective.includes('Pre-register') && services.includes('medical-pre-register'),
      // width: '10%',
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('title_th'),
    },
    {
      title: 'คำนำหน้าอื่นๆ (ภาษาไทย)',
      dataIndex: 'special_title_th',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-teacher-pre-register') || objective.includes('edu-officer-pre-register') || (services.includes('one-id') || objectiveCheck.includes('ra') || services.includes('one-id-pmuc')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'คำนำหน้าอื่นๆ (ภาษาอังกฤษ)',
      dataIndex: 'special_title_eng',
      width: 180,
      editable: true,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-teacher-pre-register') || objective.includes('edu-officer-pre-register') || (services.includes('one-id') || objectiveCheck.includes('ra') || services.includes('one-id-pmuc')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ฉายา (ไทย)',
      dataIndex: 'nickname_th',
      width: 180,
      editable: true,
      show: objective.includes('edu-teacher-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ฉายา (อังกฤษ)',
      dataIndex: 'nickname_eng',
      width: 180,
      editable: true,
      show: objective.includes('edu-teacher-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ระดับการศึกษา',
      dataIndex: 'degree',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'คณะ',
      dataIndex: 'faculty',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'Major (สาขา/ภาควิชา)',
      dataIndex: 'major',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'Minor (ถ้ามี)',
      dataIndex: 'minor',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'สถานะการศึกษา',
      dataIndex: 'status',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'วันเกิด (ปปปป-ดด-วว)',
      dataIndex: 'birth_date',
      width: 180,
      editable: true,
      show: services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
      render: (_) => {
        return <>{_}</>
      }
    },
    {
      title: 'รหัสนักศึกษา',
      dataIndex: 'student_id',
      width: 180,
      editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'username',
      dataIndex: 'username',
      width: 180,
      editable: true,
      show: services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'password',
      dataIndex: 'password',
      width: 180,
      editable: true,
      show: services.includes('edu-teacher-pre-register') && objective.includes('edu-teacher-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'เลขประจำตัวบุคลากรทางการแพทย์',
      dataIndex: 'employee_id',
      width: 180,
      editable: true,
      hidden: !objective.includes('Pre-register'),
      show: services.includes('medical-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      width: 180,
      editable: true,
      show: objective.includes('Pre-register'),

      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ชื่อ (ภาษาไทย)',
      dataIndex: 'name_th',
      width: 150,
      // width: '10%',
      editable: true,
      show: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ชื่อกลาง (ภาษาไทย)',
      dataIndex: 'middle_name_th',
      width: 150,
      // width: '10%',
      editable: true,
      show: objective.includes('edu-officer-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'นามสกุล (ภาษาไทย)',
      dataIndex: 'surname_th',
      width: 150,
      show: true,
      // width: '10%',
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('surname_th'),
    },
    {
      title: 'ชื่อ (ภาษาอังกฤษ)',
      dataIndex: 'name_eng',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_eng'),
    },
    {
      title: 'ชื่อกลาง (อังกฤษ)',
      dataIndex: 'middle_name_eng',
      width: 150,
      // width: '10%',
      editable: true,
      show: objective.includes('edu-officer-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'นามสกุล (ภาษาอังกฤษ)',
      dataIndex: 'surname_eng',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('surname_eng'),
    },
    {
      title: 'ประเภทบัตร',
      dataIndex: 'id_card_type',
      width: 150,
      show: objective.includes('edu-officer-pre-register') || objective.includes('edu-student-pre-register'),
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'เลขประจำตัวประชาชน',
      dataIndex: 'cid',
      width: 150,
      show: true,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'ที่อยู่ของหน่วยงาน',
      dataIndex: 'address',
      width: 400,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: objective.includes('CA') || objective.includes('import-excel-rama') || objective.includes('contract-no') || objective.includes('เลขที่หนังสือสัญญา'),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      width: 400,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: !(services.includes('ca') || services.includes('contract-no')) && !objective.includes('CA'),
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'โทรศัพท์',
      dataIndex: 'tel',
      width: 150,
      editable: true,
      show: false,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('tel'),
    },
    {
      title: 'โทรศัพท์มือถือ',
      dataIndex: 'mobile',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('mobile'),
    },
    {
      title: 'อีเมล',
      dataIndex: 'email',
      width: 250,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('email'),
    },
    {
      title: 'อีเมลองค์กร',
      dataIndex: 'biz_email',
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
    },
    {
      title: 'username',
      dataIndex: 'username',
      width: 180,
      editable: true,
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'วันเกิด',
      dataIndex: 'birth_date',
      width: 150,
      editable: true,
      show: objective.includes('Pre-register') || objective.includes('edu-officer-pre-register') || objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'ตำแหน่งของเจ้าของใบรับรอง',
      dataIndex: 'position',
      width: 150,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
      // ...getColumnSearchProps('position'),
    },
    {
      title: 'ชื่อองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'organization',
      width: 250,
      editable: true,
      show: objective.includes('Pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('email'),
    },
    {
      title: 'ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'sub_organization',
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
      // ...getColumnSearchProps('sub_organization'),
    },
    {
      title: 'ชื่อองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'organization',
      width: 350,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล',
      dataIndex: 'tax_id',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")

    },
    {
      title: 'ชื่อคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_1',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'นามสกุลคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_1',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'ชื่อคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_2',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'นามสกุลคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_2',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'ชื่อคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_3',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'นามสกุลคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_3',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'ชื่อคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_4',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'นามสกุลคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_4',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'อีเมล 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_1',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'อีเมล 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_2',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'อีเมล 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_3',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'อีเมล 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_4',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'โทรศัพท์มือถือ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_1',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'โทรศัพท์มือถือ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_2',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'โทรศัพท์มือถือ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_3',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'โทรศัพท์มือถือ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_4',
      width: 200,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub")
    },
    {
      title: 'แผนก',
      dataIndex: 'department',
      width: 120,
      show: services.includes('one-id') && objectiveCheck.includes('ra')
    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      width: 120,
      show: services.includes('one-id') && objectiveCheck.includes('ra')
    },
    {
      title: 'สถานะ',
      dataIndex: 'is_duplicate',
      width: 130,
      fixed: 'right',
      show: true,
      render: (is_duplicate) => (
        is_duplicate
          ? <Tag color="warning">มีในระบบแล้ว</Tag>
          : <Tag color="success">สร้างสำเร็จ</Tag>
      )
    },
    // {
    //   title: 'age',
    //   dataIndex: 'age',
    //   width: '15%',
    //   editable: true,
    // },
    // {
    // title: 'operation',
    // dataIndex: 'operation',
    // width: 200,
    // fixed: 'right',
    // render: (_, record) => {
    //   const editable = isEditing(record);
    //   return editable ? (
    //   <span>
    //     <Button
    //     type='primary'
    //     onClick={() => save(record.index)}
    //     style={{
    //         marginRight: 8,
    //         background:'#53BE35'
    //     }}
    //     >
    //       บันทึก
    //     </Button>
    //     <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
    //       <a>ยกเลิก</a>
    //     </Popconfirm>
    //   </span>
    //   ) : (
    //   <>
    //     <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
    //         <ModeEditOutlinedIcon style={{color: style.primary_color ?? '#053075'}}/>
    //     </Typography.Link>
    //     {data.length >= 1 ? (
    //       <Popconfirm title="Sure to delete?" 
    //       disabled
    //       onConfirm={() => 
    //           handleDelete(record.index)
    //       }>
    //           <DeleteOutlinedIcon style={{color:'#c7c7c7'}}/>
    //       </Popconfirm>
    //       ) : null
    //     }
    //   </>
    //   );
    // },
    // },
  ].filter(head => !head.hidden && head.show).map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ||
          col.dataIndex === 'index' ||
          col.dataIndex === 'no' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  // end edit table
  return (
    <>
      {/* <Row style={{marginBottom:'20px'}}>
            <Col className="d-flex justify-content-end">
              <Button size="large" > <RefreshIcon/> Resend Mail </Button>
            </Col>
          </Row> */}
      <Row>
        {/* ui table */}
        <Form form={form} component={false}>
          <Table
            locale={customLocale}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            bordered
            dataSource={data}
            columns={mergedColumns}
            rowClassName="editable-row"
            pagination={{
              onChange: cancel,
            }}
            scroll={{
              x: 1400,
              y: 400,
            }}

          />
        </Form>
        {/* end ui table */}
      </Row>
    </>
  )

}
export default AddSuccess